import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useRouter } from '../../../../@casino/useRouter';
import { useDispatch, useSelector } from 'react-redux';
import { setGetPinsale } from '../../../store/requestApi/thunk/pinsale/thunk/setGetPinsale';
import { format } from 'date-fns';
import Table from '../../../../@casino/ui/table';
import ModalCreatePinsale from '../components/ModalCreate';
import ModalEditPinsale from '../components/ModalEdit';

const Pinsale = () => {
    const router = useRouter();

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetPinsale());
    }, []);

    const [isShowModalCreate, setIsShowModalCreate] = React.useState(false);
    const [isShowModalEdit, setIsShowModalEdit] = React.useState(false);
    const [selectedId, setSelectedId] = React.useState()

    const handleChangeModeCreate = () => {
        setIsShowModalCreate(value => !value);
    }

    const handleChangeModeEdit = () => {
        setIsShowModalEdit(value => !value);
    }

    const handleSelected = (row) => {
        setSelectedId(row.id)
    }

    const columns = [
        { id: 'created_ad', label: 'Дата создания'},
        { id: 'start_date', label: 'Дата начала'},
        { id: 'end_date', label: 'Дата окончания'},
        { id: 'pinsale', label: 'Pinsale'},
        { id: 'count', label: 'Осталось активаций'},
        { id: 'bonus', label: 'Бонус'},
        { id: 'value', label: 'Количество Бонуса'},
        { id: 'game_uuid', label: 'Игра'}
    ];

    const pinsale = useSelector(state => state.pinsale.list);

    const rows = pinsale.map((item) => {
        return {
            id: item.id,
            created_ad: format(new Date(+item.created_at), 'dd.MM.yyyy'),
            start_date: format(new Date(+item.start_date), 'dd.MM.yyyy'),
            end_date: format(new Date(+item.end_date), 'dd.MM.yyyy'),
            pinsale: item.pinsale,
            count: item.count,
            bonus: item.bonus,
            value: item.value,
            game_uuid: item.game_uuid
        }
    })

    return (
        <div style={{
            padding: '0 20px'
        }}>
        <Title
            label="Список Pinsale" 
            labelBtn="Добавить Pinsale" 
            button={handleChangeModeCreate}
        />  
            <div style={{
                margin: '12px 0',
                display: 'flex',
                padding: '20px',
                background: '#1b2039',
                alignItems: 'center',
                borderRadius: '8px',
            }}>
                <Table
                    columns={columns}
                    rows={rows}
                    handleClick={(row) => {
                        handleSelected(row);
                        handleChangeModeEdit();
                    }}
                />
            </div>
            {
                isShowModalCreate && (
                    <ModalCreatePinsale handleChangeMode={handleChangeModeCreate} />
                )
            }
            {
                isShowModalEdit && (
                    <ModalEditPinsale handleChangeMode={handleChangeModeEdit} selectedId={selectedId} />
                )
            }
        </div>
    )
}

export default Pinsale;